import api from 'api'

const getCertificate = (certificateId: number) => {
  return api.get(`/administration/certificates/${certificateId}`).then(({ data }) => {

    const signers = data.data.attributes.signersAttributes.data.map(({ attributes }: any) => attributes)

    const aux = {
      ...data.data.attributes,
      certificateCourseAttributes: data.data.attributes.certificateCourseAttributes,
      signersAttributes: signers
    }

    return aux
  })
}

export default getCertificate
